import * as React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import BoxList from 'modules/core/components/BoxList'
import ScrollableList from 'modules/core/components/ScrollableList'
import createComputed from 'modules/core/hooks/createComputed'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'
import { matchText } from 'modules/core/lib/stringUtils'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import Controls from './Controls'
import List from './List'

const useFilteredLegalEntities = createComputed((legalEntities: LegalEntity[], search: string) =>
  legalEntities.filter((x) => matchText(search, x.attributes.legal_name))
)

interface Props {
  legalEntities: LegalEntity[]
  onSelect: (id: string | null | undefined) => void
  onSelectMultiple?: ((selectedIds: string[]) => void) | null
  selectedIds: string[]
  withSearch?: boolean
}

function LegalEntitySelector({
  legalEntities,
  onSelect,
  onSelectMultiple,
  selectedIds,
  withSearch,
}: Props) {
  const onSelectLegalEntity = (legalGender: LegalEntity) => () =>
    onSelect(legalGender.attributes.id)
  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const filteredLegalEntities = useFilteredLegalEntities(legalEntities, debouncedSearch).get()

  return (
    <BoxList>
      {withSearch && (
        <Box width="full" padding="s8" background="grey200">
          <SearchField
            variant="big"
            search={search}
            onSearch={onSearch}
            placeholder={i18n.t('common.search')}
          />
        </Box>
      )}
      <Controls
        legalEntities={filteredLegalEntities}
        disabled={false}
        selectedIds={selectedIds}
        onSelectMultiple={onSelectMultiple}
      />
      <ScrollableList>
        <List
          onSelectMultiple={(selectedIds) => {
            return onSelectMultiple && onSelectMultiple(selectedIds)
          }}
          onSelectLegalEntity={onSelectLegalEntity}
          selectedIds={selectedIds}
          legalEntities={filteredLegalEntities}
        />
      </ScrollableList>
    </BoxList>
  )
}

export default observer(LegalEntitySelector)
